// extracted by css-extract-rspack-plugin
export default {"tabsPanel":"PMOaj"};